import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CreatePaymentRedirectUrlDto } from '../../../service/dto/create-payment-redirect-url.dto';
import { PaymentHelperService } from '../../../service/payment-helper.service';
import { PaymentProviderEvent } from '../../event/payment-provider.event';
import { PaymentMethodEnum } from '../../model/payment-method.enum';
import { PaymentPreInitModel } from '../../model/payment-pre-init.model';
import { PaymentProviderComponentInterface } from '../payment-provider.component.interface';
import { PaymentViewModel } from '@dinein-lib/restapi-plugin';
import { ENVIRONMENT_TOKEN } from '@dinein-lib/core';

@Component({
  selector: 'app-payment-provider-sandbox-component',
  templateUrl: './sandbox-payment-provider.component.html',
})
export class SandboxPaymentProviderComponent implements PaymentProviderComponentInterface, OnInit {
  env: any;

  @Output() public events = new EventEmitter<PaymentProviderEvent>();

  public paymentMethod = PaymentMethodEnum;
  public readonly paymentProviderIdentifier: string = 'sandbox';
  public paymentChannel: string = null;

  public constructor(@Inject(ENVIRONMENT_TOKEN) protected environment: any, private paymentHelperService: PaymentHelperService, private route: ActivatedRoute) {
    this.env = environment;
  }

  public ngOnInit(): void {
    this.paymentChannel = this.env.payment.channel;
  }

  public onPostInitPayment(paymentModel: PaymentViewModel): void {
    setTimeout(() => {
      if (paymentModel.plainPayload) {
        window.location.href = paymentModel.plainPayload;
        return;
      }

      const request: CreatePaymentRedirectUrlDto = new CreatePaymentRedirectUrlDto();
      request.paymentChannel = this.paymentChannel;
      request.route = this.route;

      window.location.href = this.paymentHelperService.createPaymentRedirectUrl(request);
    }, 2000);
  }

  public onPreInitPayment(event: PaymentPreInitModel): Observable<PaymentPreInitModel> {
    return new Observable<PaymentPreInitModel>((subscriber) => {
      event.intPayMethodType = 'user';
      event.intPayMethodValue = '';
      subscriber.next(event);
      subscriber.complete();
    });
  }
}
